app.controller('OrderHistoryArchiveController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    $scope.order_type_id = "order";

    $scope.search_model = new $rootScope.model_constructor.SearchModel();

    const orderListModels = {
        order: new $rootScope.model_constructor.ListModel(),
        weborder: new $rootScope.model_constructor.ListModel()
    }

    $scope.getOrderListModel = function () {
        return orderListModels[$scope.order_type_id];
    }

    $scope.archiveSearch = function () {

        const searchModel = $scope.search_model;
        searchModel.prepare();
        $rootScope.service.order_history.requestArchive($scope.order_type_id, $scope.getOrderListModel(), searchModel);
    };

    $scope.showOrder = function (order) {
        if (order.type === 'order') {
            $state.go('myba.order-history-submitted-entry.entry', {order_id: order.id});
        } else {
            $state.go('myba.order-history-web-entry.entry', {order_id: order._id});
        }
    };

    $scope.startNewOrder = function () {
        $rootScope.service.order.startNewOrder();
        $state.go('myba.dashboard');
    }
}]);